// import BrowserDetect from './BrowserDetect';
import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
// import Accordion from './Accordion';
// import Tab from './Tab';
import SpNavi from './SpNavi';
// import ToTop from './ToTop';
// import DropDownMenu from './DropDownMenu';
// import BlockLink from './BlockLink';
// import Gmap from './Gmap';
// import matchheight from 'jquery-match-height';
// import inview from 'jquery-inview';
// import {TweenMax, TimelineMax} from "gsap";
import bowser from "bowser";
// import Fullpage from 'fullpage.js';
// if (bowser.msie === true) {
// 	let version = "ie_" + Math.floor(bowser.version);
// 	$("body").addClass("ie " + version);
// } else if (bowser.msedge === true) {
// 	$("body").addClass("edge");
// } else if (bowser.firefox === true) {
// 	$("body").addClass("ff");
// } else if (bowser.tablet === true) {
// 	$("body").addClass("tablet");
// }
// if (bowser.mobile === true) {
// 	$("body").addClass("device--mobile");
// 	if (bowser.android === true) {
// 		console.log('ANdoroid')
// 		$("body").addClass("device--mobile--android");
// 	}
// }

var userAgent = window.navigator.userAgent.toLowerCase();

if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
	$('body').addClass('ie');
} else if(userAgent.indexOf('edge') != -1) {
	$('body').addClass('edge');
} else if(userAgent.indexOf('chrome') != -1) {
    // console.log('Google Chromeをお使いですね');
} else if(userAgent.indexOf('safari') != -1) {
    // console.log('Safariをお使いですね');
} else if(userAgent.indexOf('firefox') != -1) {
    // console.log('FireFoxをお使いですね');
} else if(userAgent.indexOf('opera') != -1) {
    // console.log('Operaをお使いですね');
} else {
    // console.log('そんなブラウザは知らん');
}


import link_icon from './link_icon';
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */


let spnav_accordion_1 = (scroller)=>{
	setTimeout(function(){
		scroller.refresh();
	},300);
	$('.l-contents_inner').on('click',function(){
		scroller.refresh();
	});
	$(window).on('orientationchange resize', function() {
		scroller.refresh();
	});
	$('.btn_sp_navi_wrap').on('click',function(){
		scroller.refresh();
	});
}

//通常盤
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec(spnav_accordion_1 );

//game
let param_game = {
	target:'#spnavi-game',
	trigger:'.js-hero_button',
	filter:'resposive_flg',
	speed:200
};
const game = new SpNavi(param_game);
game.exec(spnav_accordion_1 );

//param_spnavi_button
let param_spnavi_button = {
	target:'#spnavi-game',
	trigger:'.js-spnavi_button',
	filter:'resposive_flg',
	speed:200
};
const spnavi_button = new SpNavi(param_spnavi_button);
spnavi_button.exec(spnav_accordion_1 );


//execに可変引数で処理を渡してナビの開閉時に処理させるサンプル
//例として、SPナビでアコーディオンを開くたびにiScrollをリセットする
// let spnav_accordion_1 = (scroller)=>{
// 	$('#scroller .inner > ul > li > span').off();
// 	$('#scroller .inner > ul > li > span').on('click',function(){
// 		let $parent = $(this).parent('li');
// 		let $child = $(this).next('.gnavi-child');
// 		let status = $child.css('display');

// 		if(status == 'block'){
// 			$child.slideUp(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.removeClass('active');
// 		}else{
// 			$child.slideDown(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.addClass('active');
// 		}

// 		return false;
// 	});
// }
// spnavi.exec(spnav_accordion_1);
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
// const totop = new ToTop('#totop','#global_footer',100,400);
// totop.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
link_icon();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });

/* ===============================================
instagram with infinityScroll

markup:
<div class="slide--instagram_wrapper" id="insragram">
	<div class="slide--instagram">
		<div id="js-slide--instagram">
			<ul class="inner"></ul>
		</div>
	</div>
</div>
=============================================== */
/**
 *
 * @param {sring} requet_url instagramのリクエストURL ./_instagram_template.htmlにhtmlテンプレートサンプルあり
 * @param {element} append_target 読み込んだ写真を追加する要素
 * @param {element} slide_target スライドショーさせる要素
 */
// import instagram from './instagram';
// instagram('request_url','#js-slide--instagram .inner','#js-slide--instagram');


/**/
// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
let vh = window.innerHeight * 0.01;
// カスタム変数--vhの値をドキュメントのルートに設定
document.documentElement.style.setProperty('--vh', `${vh}px`);


const buttonArray = document.querySelectorAll(".c-QaButton");
let ClickCount = 1;

const count = e => {
	ClickCount++;
	const AllNumEl = document.querySelectorAll('.p-qaBox_num');

	for(let $i = 0;  AllNumEl.length > $i; $i++){
		AllNumEl[$i].innerHTML = `Q${ClickCount}`;
	}
	const targetEl = e.currentTarget;
	const targetDataLink = targetEl.getAttribute("data-link");
	const qaActiveEl = document.querySelector(".p-qaBox_wrap.active");
	const nextEl = document.querySelector(targetDataLink);
	qaActiveEl.classList.add("checked");
	nextEl.classList.add("active");
	const qaInnerEl = document.querySelector(".p-qaBox_inner");
	setTimeout(function () {
		qaInnerEl.classList.add("active");
	},400);
};

for (let i = 0; i < buttonArray.length; i++) {
	buttonArray[i].addEventListener("click", count, false);
}

(function(){
	setTimeout(function(){
		$(".p-hero_main_logo").addClass('-show');
		$(".p-hero_main_eyeCatch").addClass('-show');
		setTimeout(function () {
			$(".p-hero_inner").addClass('-show');
			setTimeout(function () {
				$(".p-hero_text").addClass('-show');
			},1500)
			setTimeout(function(){
				$(".p-hero_button").addClass('-show');
			},1750)
		},500)
	},0);
}());

/* ===============================================
#	Cookie処理
=============================================== */

const obj = convertCookieToObject(document.cookie);

function convertCookieToObject(cookies){
	const cookieItem = cookies.split(';');
	const obj = {};
	cookieItem.forEach((item) => {
		let elem = item.split('=');
		const key = elem[0].trim();
		const val = decodeURIComponent(elem[1]);
		obj[key] = val;
	});
	return obj;
}

/* ===============================================
#	下層からの診断ボタンを押すとqaページを開く。
=============================================== */

const js_spnavi_button_lower = document.querySelector('.js-spnavi_button_lower');

if(js_spnavi_button_lower){
	js_spnavi_button_lower.addEventListener('click',function(){
		document.cookie = `spnavi_button_lower=true_str;`;
	});
}

if(obj.spnavi_button_lower === 'true_str'){
	document.cookie = `spnavi_button_lower=false_str;`;
	document.querySelector('.js-hero_button').click();
}

